import { downgradeComponent } from '@angular/upgrade/static';
import angular from 'angular';
import { MarkerComponent } from './marker.component';
export { MarkerModule } from 'ngx/go-modules/src/components/marker/marker.module';

export const ngxMarkerModule = angular.module('ngxMarkerModule', [])
	.directive('ngxMarker', downgradeComponent({ component: MarkerComponent }))
	.name;
